import { useState, useEffect } from "react";
import { Box, Typography } from "@mui/material";
import { blackColor, lightGrayColor } from "../constants/colors";

const ImagePreview = ({ imageUrl }) => {
  const [imageUrlValue, setImageUrlValue] = useState(imageUrl);

  useEffect(() => {
    setImageUrlValue(imageUrl);
  }, [imageUrl]);

  return (
    <Box
      sx={{
        width: "100px",
        height: "100px",
        borderWidth: "1px",
        borderStyle: "solid",
        borderColor: blackColor,
        backgroundColor: lightGrayColor,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      {imageUrlValue ? (
        <img
          src={imageUrlValue}
          alt="Preview"
          style={{ width: "100%" }}
          onError={(e) => {
            setImageUrlValue(null);
          }}
        />
      ) : (
        <Typography
          sx={{ color: blackColor, fontWeight: "500", fontSize: "20px" }}
        >
          PREVIEW
        </Typography>
      )}
    </Box>
  );
};

export default ImagePreview;
